import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DsIconModule, DsTooltipDirectiveModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';

@Component({
  selector: 'cdf-bmw-mini-id',
  imports: [DsIconModule, DsTooltipDirectiveModule],
  template: `
    <div class="container-fluid">
      <div class="row flex-nowrap">
        <div class="col-auto">
          @if (bmwOrMiniId()) {
            <ds-icon class="icon" size="md" tone="positive" icon="checkbox_circle" />
          } @else {
            <ds-icon class="icon" size="md" icon="close_circle" />
          }
        </div>

        <div class="col text-col">
          <h4 class="row">{{ i18n('bmwOrMiniId') }}</h4>
          @if (bmwOrMiniId()) {
            <span class="row text-neutral">{{ bmwOrMiniId() }}</span>
          } @else {
            <a
              class="row"
              [class.hyperlink]="!readonly()"
              [class.text-neutral]="readonly()"
              [ds-tooltip]="i18n('readonlyTooltip')"
              [dsTooltipConfig]="{ disabled: !readonly(), origin: 'bottom', showTriggerDelay: 500 }"
              (click)="tryCreatingBmwMiniId()"
              >{{ i18n('createBmwOrMiniId') }}</a
            >
          }
        </div>
      </div>
    </div>
  `,
  styleUrl: './bmw-mini-id.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BmwMiniIdComponent {
  readonly i18n = useI18n();

  readonly createBmwMiniId = output();
  readonly bmwOrMiniId = input<string>();
  readonly readonly = input(false);

  protected tryCreatingBmwMiniId() {
    if (!this.readonly()) {
      this.createBmwMiniId.emit();
    }
  }
}
